<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Entry -->
        <b-col
          cols="12"
          md="9"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('globalActions.find')"
            />
          </div>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="3"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >

        </b-col>
      </b-row>
    </div>

    <b-table
      id="refListTable"
      ref="refListTable"
      no-provider-paging
      no-provider-filtering
      :filter-ignored-fields="columnToNotBeFilter"
      :fields="tableColumns"
      :items="itemLists"
      :per-page="perPage"
      :current-page="currentPage"
      :filter="searchQuery"
      responsive
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :busy="isBusy"
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >

      <template #table-busy>
        <div class="text-center text-primary my-2 d-flex flex-column justify-content-center">
          <div class="text mb-1">
            <b-spinner class="align-middle" />
          </div>
          <strong>{{ $t('globalActions.fetchingDataAPI') }}</strong>
        </div>
      </template>

      <!-- Column: name -->
      <template #cell(picName)="data">
          <b-link
            :to="{ name: 'apps-master-data-user-detail', params: { id: data.item.id }}"
            class="font-weight-bold"
          >
          <span class="font-weight-bolder d-block text-nowrap">{{ data.item.user.user_name }}</span>
          <small class="font-italic text-secondary">({{ data.item.user.user_code }})</small>
          </b-link>
      </template>

      <!-- Column: email -->
      <template #cell(picEmail)="data">
          {{ data.item.user.user_email }}
      </template>
      
      <!-- Column: role -->
      <template #cell(role)="data">
        <span class="font-weight-bolder d-block text-nowrap">{{ !data.item.roles || !data.item.roles.name ? '' : data.item.roles.name }}</span>
      </template>

      <!-- Column: office -->
      <template #cell(office)="data">
        <span class="font-weight-bolder d-block text-nowrap">{{ !data.item.office || !data.item.office.name ? '' : data.item.office.name }}</span>
        <div v-if="data.item.office">
          <small class="font-italic text-secondary">({{ !data.item.office || !data.item.office.code ? '' : data.item.office.code }})</small>
        </div>
      </template>

      <!-- Column: National -->
      <template #cell(isNational)="data">
        <span class="font-weight-bolder d-block text-nowrap">{{ !data.item.is_national ? 'FALSE' : 'TRUE' }}</span>
      </template>

      <!-- Column: Active -->
      <template #cell(isActive)="data">
        <span class="font-weight-bolder d-block text-nowrap">{{ !data.item.is_active ? 'FALSE' : 'TRUE' }}</span>
      </template>

    </b-table>

    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalList"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            aria-controls="refInvoiceListTable"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>

  </b-card>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BLink,
  BPagination,
  BSpinner
} from 'bootstrap-vue'

// import useList from './useList'
import useListTable from '@/comp-functions/useListTable'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BLink,
    BPagination,
    BSpinner
  },
  setup () {
    // Table Handlers
    const tableColumns = [
      { key: 'picName', label: 'Name' },
      { key: 'picEmail', label: 'Email' },
      { key: 'role', label: 'Role' },
      { key: 'office', label: 'Office' },
      { key: 'isNational', label: 'National' },
      { key: 'isActive', label: 'Active' }
    ]
    
    // Table Handlers
    const columnToNotBeFilter = [
      'isNational',
      'isActive'
    ]

    
    return {
      tableColumns,
      columnToNotBeFilter,
      ...useListTable({
        url: 'master/user'
      })
    }
  }
}
</script>
